import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AnotacionCalendario } from 'src/app/compartido/calendario/utilidades/calendario.models';
import { deepCopy } from 'src/app/compartido/utilidades/objetos.utils';
import { CONFIGURACION_FICHA_CALENDARIO_GENERAL } from './utilidades/calendario-general.static';

@Component({
    selector: 'nucleo-calendario-general',
    templateUrl: './calendario-general.component.html',
    styleUrls: ['./calendario-general.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CalendarioGeneralComponent {
  /* Configuración ficha */
  protected readonly configFicha = deepCopy(
    CONFIGURACION_FICHA_CALENDARIO_GENERAL,
  );

  constructor() {}

  protected anotaciones: AnotacionCalendario[] = [
    {
      fecha: new Date(),
      datos: {
        titulo: 'Netflix',
      },
    },
    {
      fecha: new Date(),
      datos: {
        titulo: 'Google One',
      },
    },
    {
      fecha: new Date(),
      datos: {
        titulo: 'Youtube Premium',
      },
    },
  ];
}
